import React from 'react';
import { FormikValues, useFormikContext } from 'formik';
import useDebouncedEffect from '../../../hooks/useDebouncedEffect';

interface Props<Values extends FormikValues = any> {
  onChange?: (values: Values) => void;
  debounceTime?: number;
}

function ValuesListener({ onChange, debounceTime = 250 }: Props) {
  const { values } = useFormikContext();

  const previousValues = React.useRef(values);

  useDebouncedEffect(
    () => {
      if (!onChange || !values) return;
      onChange(values);
      previousValues.current = values;
    },
    [onChange, values],
    debounceTime,
  );

  return null;
}

export default ValuesListener;
